export default "/reset_password/:token";
